import React, { useEffect, useState } from 'react';
import "./Home.css";
import Product from './Product.js';
import CookieWidget from './CookieWidget.js';
import { db } from './firebase';
import {
  collection,
  query,
  orderBy,
  limit,
  getDocs,
  where,
  doc,
  getDoc,
  updateDoc
} from 'firebase/firestore';


function Home() {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const fetchTopProducts = async () => {
      const topQuery = query(
        collection(db, 'prodotti'),
        orderBy('searchCount', 'desc'),
        limit(6)
      );

      const snapshot = await getDocs(topQuery);
      let topProducts = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

      if (topProducts.length === 0) {
        const fallbackQuery = query(
          collection(db, 'prodotti'),
          where('featured', '==', true),
          limit(6)
        );
        const fallbackSnapshot = await getDocs(fallbackQuery);
        topProducts = fallbackSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      }

      setProducts(topProducts);
    };

    fetchTopProducts();
  }, []);

  return (
    <div className='home'>
      <div className='home_container'>
        <img className="immagine_sfondo" src="foto_uno.png" alt='Sfondo'/>
      </div>

      <div className='home_products'>
        <div className='home_row'>
          {products.slice(0, 2).map((product) => (
              <Product
              key={product.originalID ?? product.id}
              id={product.originalID ?? product.id}
              title={product.title}
              description={product.description}
              price={product.price}
              image={product.image}
              variants={product.variants}
              navigateOnClick={true}
              />
          ))}
        </div>

        <div className='home_row'>
          {products.slice(2, 5).map((product) => (
              <Product
              key={product.originalID ?? product.id}
              id={product.originalID ?? product.id}
              title={product.title}
              description={product.description}
              price={product.price}
              image={product.image}
              variants={product.variants}
              navigateOnClick={true}
              />
          ))}
        </div>

        <div className='home_row'>
          {products.slice(5, 6).map((product) => (
              <Product
              key={product.originalID ?? product.id}
              id={product.originalID ?? product.id}
              title={product.title}
              description={product.description}
              price={product.price}
              image={product.image}
              variants={product.variants}
              navigateOnClick={true}
              />
          ))}
        </div>
      </div>

      <CookieWidget />
    </div>
  );
}

export default Home;
